
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Date from "../../../../utils/date";
import { useNavigate } from "react-router-dom";
import ListaVazia from "../../../../utils/listaVazia";
import Paginacao from "../../../../utils/paginacao";
import TempoPassado from "../../../../utils/tempoPassado";
import TabelaLoading from "../../../../load/tabelaLoading";
import DataInicioFimFilter from "../../../../filters/dataInicio_dataFinal_Filter";
import TipoExpedienteFilter from "../../../../filters/tipoExpedienteFilter";
import ExpedienteEntradaFilter from "../../../../filters/expedienteEntradaFilter";


const styles = {
    hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
    container: {
        display: 'flex',
        justifyContent: 'center',
        boxShadow: 'none',
        margin: 10
    },
}

export default function ListaExpediente({ expedientes, configLista, page, setPage, setPerPage, setDataInicio, setDataFim, dataInicio, dataFim, setDocumento,documento, filtraentradas }) {

    const classes = styles
    const navigate = useNavigate()

    return (
        expedientes ?
            <TableContainer sx={{ border: "1px black" }} component={Paper}>
                <Table sx={{ border: "1px", borderColor: "black" }}>
                    <TableHead sx={{ backgroundColor: "#dcdede" }}>
                        <TableRow>
                            {/* <TableCell align="center" ><Typography noWrap> <strong>Requerente / Nome </strong></Typography></TableCell> */}
                            <TableCell align="center" ><Typography noWrap> <strong> Nº Registo </strong></Typography></TableCell>
                            <TableCell align="center" ><Typography noWrap> <strong>Portador / Remetente </strong></Typography></TableCell>
                            {/* <TableCell align="center" ><Typography noWrap> <strong> Instituição / B.I ou NIF Empresa / NIF </strong></Typography></TableCell> */}
                            <TableCell align="center" ><Typography display={'flex'} alignItems={'center'} noWrap>
                                <strong> Tipo de Documento </strong>
                                <TipoExpedienteFilter setDocumento={setDocumento} documento={documento}/>
                            </Typography></TableCell>
                            <TableCell align="center" ><Typography noWrap> <strong> Nº </strong></Typography></TableCell>
                            <TableCell align="center" ><Typography display={'flex'} alignItems={'center'} noWrap> 
                                <strong> Assunto </strong>
                                <ExpedienteEntradaFilter filtraentradas={filtraentradas} />
                            </Typography></TableCell>
                            {/* <TableCell align="center" ><Typography noWrap> <strong> Data do Documento </strong></Typography></TableCell> */}
                            <TableCell align="center" ><Typography noWrap> <strong> email </strong></Typography></TableCell>
                            <TableCell align="center" ><Typography noWrap> <strong> contacto </strong></Typography></TableCell>
                            {/* <TableCell align="center" ><Typography noWrap> <strong> Anexo </strong></Typography></TableCell> */}
                            <TableCell align="center" ><Typography display={'flex'} alignItems={'center'} noWrap>
                                <strong> Data Registo </strong>
                                <DataInicioFimFilter setDataInicio={setDataInicio} setDataFim={setDataFim} dataInicio={dataInicio} dataFim={dataFim} />
                            </Typography></TableCell>
                            <TableCell align="center" ><Typography noWrap> <strong> Ultima Intervenção </strong></Typography></TableCell>
                            {/* <TableCell align="center" ><Typography noWrap> <strong> Destinatário </strong></Typography></TableCell> */}
                            {/* <TableCell align="center" ><Typography noWrap> <strong> Visualizar Anexo </strong></Typography></TableCell> */}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {expedientes.map((expediente) => (
                            <TableRow key={expediente._id} style={classes.hover} onClick={() => navigate(`/admin/expediente/view/${expediente._id}`)}>

                                {/* <TableCell ><Typography noWrap> {expediente?.remetidoPor?.nome}</Typography></TableCell> */}
                                <TableCell align="center"   ><Typography noWrap> {expediente?.numero} </Typography></TableCell>
                                <TableCell ><Typography > {expediente?.nome}</Typography></TableCell>
                                {/* <TableCell  ><Typography > {expediente?.nifBi}</Typography></TableCell> */}

                                <TableCell  ><Typography noWrap> {expediente?.tipoDocumento?.designacao}</Typography></TableCell>
                                <TableCell  ><Typography noWrap> {expediente?.numeroDocumento}</Typography></TableCell>
                                <TableCell  ><Typography > {expediente?.assunto}</Typography></TableCell>
                                {/* <TableCell align="center" ><Typography noWrap> <Date date={expediente?.createdAt} /> </Typography></TableCell> */}
                                <TableCell align="center"   ><Typography noWrap> {expediente?.email} </Typography></TableCell>
                                <TableCell align="center"   ><Typography noWrap> {expediente?.tel} </Typography></TableCell>
                                <TableCell align="center" ><Typography noWrap> <Date date={expediente?.createdAt} /> </Typography></TableCell>
                                <TableCell align="center" ><Typography noWrap> <TempoPassado date={expediente.updatedAt} /> </Typography></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {expedientes.length === 0 && <ListaVazia />}

                <Paginacao
                    configLista={configLista}
                    lista={expedientes}
                    page={page}
                    setPage={setPage}
                    setPerPage={setPerPage}
                />
            </TableContainer>
            :
            <TabelaLoading text={'A carregar expedientes'} />
    )
}